import Vue from 'vue'
import dayjs from 'dayjs'
import ptBR from 'dayjs/locale/pt-br'
import timezone from 'dayjs/plugin/timezone'
import isBetween from 'dayjs/plugin/isBetween'
import localeData from 'dayjs/plugin/localeData'
import weekday from 'dayjs/plugin/weekday'
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore'
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import utc from 'dayjs/plugin/utc'

dayjs.locale(ptBR)
dayjs.extend(timezone)
dayjs.extend(isBetween)
dayjs.extend(localeData)
dayjs.extend(weekday)
dayjs.extend(isSameOrBefore)
dayjs.extend(isSameOrAfter)
dayjs.extend(customParseFormat)
dayjs.extend(utc)
dayjs.tz.setDefault('America/Sao_Paulo')

Vue.prototype.$dayjs = dayjs
